<script>
export let visible = false;
export let type = "error";
</script>

{#if visible}
<div class="banner { type }">
  <h2><slot name="title">Something went wrong!</slot></h2>
	<p><slot name="message">:(</slot></p>
</div>
{/if}

<style>
  .banner {
    width: auto;
    padding: 6px 32px;
    margin: 32px 0;
    position: relative;
		opacity:0;
		-webkit-animation: fadeIn ease-out 1;
		-moz-animation: fadeIn ease-out 1;
		animation: fadeIn ease-out 1;
		-webkit-animation-fill-mode: forwards;
		-moz-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
		-webkit-animation-duration: 0.8s;
		-moz-animation-duration: 0.8s;
		animation-duration: 0.8s;
  }

	@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
	@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
	@keyframes fadeIn { from { opacity:0;  } to { opacity:1; } }

  .banner.error {
    background-color: #ff717f;
  }
  .banner.warning {
    background-color: #f9d731;
  }
  .banner.hidden {
    visibility: hidden;
  }
</style>

